import type { UploadFileInChunksOptions } from '@/hooks/useMediaUpload';

export const SHARE_CARD_FORM_VALUES = ['credit_card', 'profile'] as const;

export type SHARE_CARD_DETAILS_FORM_TYPE = (typeof SHARE_CARD_FORM_VALUES)[number];

/**
 * Send Forms PDFs go to sf-api media, not the Gallery (only super admins can write to it). sf-api links them
 * to the client and emails them inline, or as download links when they are too large to embed.
 */
export const SHARE_ATTACHMENT_UPLOAD_OPTIONS = {
  uploadContext: 'CLIENT_SHARE_ATTACHMENT',
  visibility: 'SENSITIVE',
} as const satisfies Pick<UploadFileInChunksOptions, 'uploadContext' | 'visibility'>;

/** Browsers still hold a previous Client's draft under this key, so the modal clears it on mount. */
export const LEGACY_SHARE_MODAL_DRAFT_STORAGE_KEY = 'share-modal-form';
